
<template>
  <div class="goods-page" v-loading="loading">
    <div class="goods-list-box" ref="goodsListBox">
      <div class="details-img">
        <h3 class="details-title">{{ detailsInfo.productName }}</h3>
        <el-image
          style="width: 200px; height: 200px;"
          :src="detailsInfo.mainImage + $ImgQuality30"
          :preview-src-list="[detailsInfo.mainImage + $ImgPreviewQuality]"
          fit="contain"
        >
          <div slot="placeholder" class="sample-image-slot">加载中</div>
          <div slot="error" class="sample-image-slot">暂无图片</div>
        </el-image>
        <div class="material-file gift-file">
          <h4 style="float: left;">文件: </h4>
          <p
            v-for="(item, index) in fileList"
            :key="index"
          >
            <el-popover
              placement="top-start"
              trigger="hover"
              popper-class="popper--upload-class"
              :disabled="popoverDisabled"
            >
              <div>
                <el-button type="text" icon="el-icon-view" @click="previewBtn(item)">预览</el-button>
                <el-button type="text" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
              </div>
              <p slot="reference">
                <i class="el-icon-document"></i>
                {{ item.name }}
              </p>
            </el-popover>
          </p>
        </div>
      </div>
    </div>
    <h3>详细信息</h3>
    <div class="goods-details-box">
      <div class="goods-details-cont">
        <span>供应商：</span>
        <el-button
          type="text"
          @click="getSupplierInfo(detailsInfo)"
          style="line-height: 4px;font-size: 14px;"
        >{{ detailsInfo.supplierName }}</el-button>
      </div>
      <div class="goods-details-cont">
        <span>联系人：</span>
        <p style="word-break: break-all;">{{ detailsInfo.contactName }}</p>
      </div>
      <div class="goods-details-cont">
        <span>手机号：</span>
        <p style="word-break: break-all;">{{ detailsInfo.contactPhone }}</p>
      </div>
      <div class="goods-details-cont">
        <span>产品一级分类：</span>
        <p style="word-break: break-all;">{{ detailsInfo.firstCategoryName }}</p>
      </div>
      <div class="goods-details-cont">
        <span>产品二级分类：</span>
        <p style="word-break: break-all;">{{ detailsInfo.secondCategoryName }}</p>
      </div>
      <div class="goods-details-cont" v-for="(item, index) in formList" :key="index">
        <span>{{ item.label }}：</span>
        <p
          style="word-break: break-all;"
          v-if="item.tag === 'el-radio'"
        >{{ detailsInfo[item.value] === 'YES' ? '是' : '否' }}</p>
        <p
          style="word-break: break-all;"
          v-else-if="item.tag === 'DictSelect'"
        >{{ detailsInfo[item.value + 'Name'] }}</p>
        <p v-else style="word-break: break-all;">{{ detailsInfo[item.value] }}</p>
      </div>
      <div class="goods-details-cont">
        <span>采购对接人：</span>
        <p style="word-break: break-all;">{{ detailsInfo.purchasingContact }}</p>
      </div>
    </div>
    <div class="preview-box" >
      <div class="preview-text" v-if="previewImgList.length > 0">
        <el-image 
          :src="require('../../../assets/images/preview.png')" 
          :preview-src-list="previewImgList">
        </el-image>
      </div>
      <div class="information" v-html="detailsInfo.productDetail"></div>
    </div>

    <!-- 预览文件 -->
    <previewFileDialog :type="fileType" :url="fileUrl" ref="previewDialog" />
    <!-- 轮播图预览 -->
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="dialogImageVisible"
      :initial-index="initialIndex > -1 ? initialIndex : 0"
      :on-close="()=> {this.dialogImageVisible = false}"
      :url-list="carouselImages"
    />
    <el-dialog
    :close-on-click-modal="false"
    :visible.sync="supplierDialog"
    title="供应商信息"
    width="30%"
  >
    <el-form :model="supplierData" label-width="150px">
      <el-form-item label="供应商名称：">
        <b>{{ supplierData.name }}</b>
      </el-form-item>
      <el-form-item label="最近合作时间：">
        <b>{{ supplierData.lastCooperationDate }}</b>
      </el-form-item>
      <el-form-item label="近2年合作次数：">
        <b>{{ supplierData.pastTwoYearsCooperationCount }}</b>
      </el-form-item>
      <el-form-item label="近2年合作金额：">
        <b>{{ supplierData.pastTwoYearsCooperationAmount }}</b>
      </el-form-item>
      <el-form-item label="年度考核等级：">
        <b>{{ supplierData.annualAssessmentLevel }}</b>
      </el-form-item>
      <el-form-item label="地址：">
        <b>{{ supplierData.address }}</b>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="supplierDialog=false">关闭</el-button>
    </span>
  </el-dialog>
  </div>
</template>
<script>
import sampleDetailsMixin from '@/mixins/sampleDetailsMixin';
import previewFileDialog from '@/components/previewFileDialog';
import download from '@/utils/download';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { FORM_LIST, FORM_MATCHUP, FIRST_TYPE_URL, FILE_List } from '@/utils/templateForm.js';

export default {
  name: 'own-details-page',
  mixins: [sampleDetailsMixin],
  components: { previewFileDialog, ElImageViewer },
  props: {},
  data() {
    return {
      supplierDialog: false,
      supplierData: {},
      popoverDisabled: false,
      dialogImageVisible: false,
      previewImgList: [],
      loading: false,
      detailsInfo: {},
      data: [],
      fileType: '',
      fileUrl: '',
      carouselImages: [],
      formList: [],
      fileList: []
    };
  },
  watch: {
    '$route': {
      handler(item) {
        if (item.name === 'own-manage/own-details-page') {
          const { id, firstCategory } = item.query;
          this.getDetail(id, firstCategory)
          setTimeout(() => {
            this.previewImgList = Array.prototype.map.call(document.querySelectorAll(`.id-${id} img`), (a) => a.src)
          }, 500)
        }
      },
      immediate: true,
    }
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll,true);
  },
  methods: {
    handleScroll() {
      const scroll = document.getElementsByClassName('el-main')[0].scrollTop
      const offsetHeight = this.$refs.goodsListBox.offsetHeight
      this.isScroll =  scroll > offsetHeight ? true: false
    },
    getDetail(id, firstCategory) {
      this.loading = true;
      const url = FIRST_TYPE_URL[firstCategory];
      this.$http.pdLibrary[url + 'Get'](id).then(result => {
        this.detailsInfo = result.data;
        this.fileList = FILE_List[FORM_MATCHUP[result.data.secondCategory]].map(item => this.detailsInfo[item.field]).flat();
        this.formList = FORM_LIST[FORM_MATCHUP[result.data.secondCategory]];
        this.$http.pdLibrary.listByFirstCategory(result.data.firstCategory).then((res) => {
          this.secondCategoryList = res.data.map(item => ({
            label: item.secondCategoryName,
            value: item.secondCategory
          }));
        })
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.loading = false;
      });
    },
    // 下载模板文件
    downloadFile({ url, name }) {
      download(url, name);
    },
    // 预览文件
    previewBtn({name, url}) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = name.substring(name.lastIndexOf('.')).toLowerCase();
      const type = ['.png','.jpeg','.jpg'].includes(fileExtend) ? 'img' : 'file';
      this.fileUrl = url;
      this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : type;
      this.$refs.previewDialog.dialogVisible = true;
    },
    // 轮播图片预览
    carouselImageChange(index) {
      this.dialogImageVisible = true
      this.initialIndex = index
    },
    getSupplierInfo (item) {
      this.$http.setting.getByCode(item.supplierCode).then(result => {
        this.supplierDialog = true;
        this.supplierData = result.data;
      })
      .catch(err => {
        this.$message.error(err.msg);
      });
    }
  },
};
</script>
<style lang="less" scoped>
.goods-page {
  max-width: 1000px;
  margin: 0 auto;
}
.goods-list-box {
  display: flex;
  padding-bottom: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #ccc;
}
.details-img {
  margin-right: 50px;
  img {
    width: 250px;
    height: 250px;
  }
}
.details-btns {
  margin: 10px 0 0 -30px;
  button {
    margin: 10px 30px;
  }
}
.details-box {
  .details-title-fixed {
    display: -webkit-box;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .details-title {
    margin-bottom: 20px;
  }
  .details-ml {
    min-height: 155px;
  }
  .details-ml,.details-ml-fixed {
    display: flex;
    overflow: auto;
    b {
      font-weight: normal;
    }
    span {
      margin: 0 5px;
    }
    .details-ml-input {
      margin-bottom: 10px;
      text-align: right;
      span {
        display: inline-block;
        margin-right: 15px;
        max-width: 80px;
      }
    }
  }
}
h3 {
  margin-bottom: 10px;
}
.goods-details-box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  .goods-details-cont {
    width: 48%;
    margin: 5px 2% 5px 0;
    font-size: 14px;
    color: #999;
    span {
      float: left;
    }
    p {
      line-height: 20px;
      word-break: break-all;
    }
  }
  .details-array span {
    display: flex;
    align-items: center;
  }
}
.btn-tips {
  font-size: 12px;
  color: #AB0033;
  padding-left: 30px;
}

/deep/ .preview-box{
  width: 100%;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ccc;
  .preview-text{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .el-image{
      vertical-align: top;
      margin-left: 5px;
      min-width: 25px !important;
      width: 25px !important;
      height: 25px !important;
    }
  }
  .information {
    margin-top: 20px;
    img {
      width: 30%;
      height: 30%;
      vertical-align: top;
    }
    word-break: break-all;
  }
}
/deep/ .information2 {
  border: none
}
.details-material {
  width: 280px;
  margin-right: 10px;
  max-height: 240px;
  overflow: auto;
  line-height: 20px;
  h4 {
    float: left;
    margin: 0 10px 10px 0;
    font-weight: normal;
  }
  p {
    margin: 5px 0 5px 10px;
    font-size: 14px;
    color: #AB0033;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.gift-file {
  width: auto!important;
}
.material-file {
  margin: 10px 0;
  width: 300px;
  max-height: 210px;
  overflow: auto;
  h4 {
    font-weight: 400;
  }
  p {
    color: #AB0033;
    cursor: pointer;
    display: block;
    line-height: 20px;
    padding-left: 50px;
    min-width: 200px;
    &:first-child {
      float: left;
      margin-left: -50px;
      margin-right: 10px;
    }
  }
  .el-popover__reference {
    color: #AB0033;
  }
}
.goods-dialog {
  .product-info-box {
    max-height: 650px;
  }
}
.cml-content-box {
  height: auto;
}
.fixed-box {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 30px;
  .el-button {
    font-size: 26px;
  }
}
</style>
<style lang="less">
.popper--upload-class {
  margin-bottom: 0px !important;
}
</style>
